import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config.js';

/** Next reports for a (day, hour) slot: { status: 'loading' | 'ready' | 'error', data }; stale responses are dropped. */
export const useSchedulePreview = ({ fetchWithAuth, configId, day, hour }) => {
  const [preview, setPreview] = useState({ status: 'loading', data: null });

  useEffect(() => {
    if (!configId) return undefined;
    let cancelled = false;
    const controller = new AbortController();
    setPreview({ status: 'loading', data: null });
    (async () => {
      try {
        const response = await fetchWithAuth(
          `${API_BASE_URL}/api/admin/configs/${configId}/schedule-preview?day=${day}&hour=${hour}`,
          { signal: controller.signal },
        );
        const data = await response.json().catch(() => null);
        if (!cancelled) setPreview(response.ok && data?.proposed ? { status: 'ready', data } : { status: 'error', data: null });
      } catch {
        if (!cancelled) setPreview({ status: 'error', data: null });
      }
    })();
    return () => { cancelled = true; controller.abort(); };
  }, [fetchWithAuth, configId, day, hour]);

  return preview;
};

export default useSchedulePreview;
